import { last } from 'lodash';

const getShowMoreNodeProps = (node, extraProps) => {
  const { nodeId: origNodeId, depth } = node;
  const { getIsProgress, ...restExtraProps } = extraProps;
  const nodeId = `${origNodeId}_MORE_ITEM`;

  return {
    visible: true,
    depth,
    nodeId,
    origNodeId,
    ...restExtraProps,
    ...(getIsProgress ? { progress: getIsProgress(nodeId) } : {}),
  };
};

const enhanceTreeNodePropsWithMore = (getTreeNodeProps) => {
  let depths = [];

  return (getTreeNodePropsArgs) => {
    const treeNodeWithShowMoreProps = getTreeNodeProps(getTreeNodePropsArgs);
    const { showMore, isLast, ...treeNodeProps } = treeNodeWithShowMoreProps;

    const result = [treeNodeProps];
    const lastDepth = last(depths) || {};

    const { getIsProgress, setProgress } = getTreeNodePropsArgs;
    const { depth, nodeId, expanded, visible } = treeNodeProps;

    const showMoreExtraProps = { renderedNodeId: nodeId, getIsProgress, setProgress };

    if (lastDepth.depth >= depth) {
      const node = depths.pop();
      result.unshift(getShowMoreNodeProps(node, showMoreExtraProps));
    }

    showMore && expanded && visible && depths.push(treeNodeProps);

    if (isLast) {
      depths = depths.reverse().filter(({ expanded, ...node }) => {
        if (expanded) {
          result.push(getShowMoreNodeProps(node, showMoreExtraProps));
        }
        return false;
      });
    }

    return result;
  };
};

export default enhanceTreeNodePropsWithMore;
